var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(!_vm.isAuthenticated)?_c('header-before-login'):[(_vm.lbilHeader === 'Lymphomap')?_c('header-after-login'):(_vm.lbilHeader === 'LBIL')?_c('lbil-header-after-login'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }